export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const API_PATH = process.env.REACT_APP_API_PATH;
export const BASE_API_URL = `${BASE_URL}${API_PATH}`;
// Chat websocket (chat-server).
export const WEB_SOCKET_URL = process.env.REACT_APP_WEB_SOCKET_URL;
// Notifications websocket (ERP gateway, e.g. https://api.notifications.dev.truckfix.net).
export const NOTIFICATIONS_SOCKET_URL =
  process.env.REACT_APP_NOTIFICATIONS_SOCKET_URL;
// export const BASE_API_URL = "https://jsonplaceholder.typicode.com";
